import { useState, useReducer } from "react";
import { connector } from "../../common/connector";
import {
    defaultItem, getResources, getItems, reducer,
    createItem, updateItem, deleteItem,

    defaultPaso, createPaso, updatePaso, deletePaso,
    estadoPaso, changeno,

    defaultPago, createPago, updatePago, deletePago,
    estadoPago,

    upload_documentos, delete_documentos
} from './functions';
import { useNotifications } from "../../common/useNotifications";
import { App } from "antd";

export const useCasos = () => {
    const { showSuccess, showInfo, showError, confirmDelete } = useNotifications();
    const [editItem, setEditItem] = useState(defaultItem);
    const [items, dispatch] = useReducer(reducer);

    const [resources, setResources] = useState({
        areas: [],
        clientes: [],
        tramites: [],
        titulares: [],
        juniors: [],
    });
    const [tableParams, setTableParams] = useState({
        pagination: { "current": 1, "pageSize": 10, "total": 0 },
        filters: {},
        sorter: {},
    });
    const [visibleForm, setVisibleForm] = useState(false);
    const [loading, setLoading] = useState(false);

    const [modalFileVisibility, setModalFileVisibility] = useState(false);
    const [fileLoading, setFileLoading] = useState(false);
    const [file, setFile] = useState(null);
    const { notification } = App.useApp();

    const fillItems = async (params = tableParams) => {
        try {
            setLoading(true);
            let { data } = await getItems(params);
            let { rows, total, current } = data;

            dispatch({ type: "FILL", payload: rows });
            setTableParams(prev => {
                return {
                    ...prev,
                    ...params,
                    pagination: {
                        ...prev.pagination,
                        ...params.pagination,
                        total: total,
                        current: current
                    }
                }
            });
        } catch (error) { throw new Error(error); }
        finally { setLoading(false); }
    }

    const fillResources = async () => {
        let res = await getResources();
        setResources({
            clientes: res.data.clientes,
            areas: res.data.areas,
            tramites: res.data.tramites,
            titulares: res.data.titulares,
            juniors: res.data.juniors
        });
    }

    const newItem = () => {
        setEditItem(defaultItem);
        setVisibleForm(true);
    }

    const selectItem = (item) => {
        setEditItem(item);
        setVisibleForm(true);
    }

    const closeForm = () => {
        setEditItem(defaultItem);
        setVisibleForm(false);
    }

    const completeItem = (item) => {
        item.cliente = resources.clientes.find(cl => cl.id === item.cliente_id);
        item.area = resources.areas.find(a => a.id === item.area_id);
        item.titular = resources.titulares.find(t => t.id === item.abogado_titular_id);
        item.junior = resources.juniors.find(j => j.id === item.abogado_junior_id);
        item.tramite = resources.tramites.find(tr => tr.id === item.tramite_id);
        return item;
    }

    const handle_save = (item) => {
        return new Promise(async (resolve, reject) => {
            try {
                if (item === editItem) { showInfo("No hay cambios."); resolve(); return; }
                setLoading(true);
                let item_action = (item.id === 0) ? createItem(item) : updateItem(item);
                let res = await item_action;

                item = completeItem(item);

                if (item.id === 0) {
                    item = { ...item, ...res.data };
                    fillItems();
                    setEditItem({ ...item });
                } else {
                    fillItems();
                    //dispatch({ type: "UPDATE", payload: item });
                }
                showSuccess("¡Guardado correcto!");
                resolve();
            } catch (e) {
                showError(e.message);
                reject(e);
            } finally { setLoading(false); }
        });
    }

    const handle_delete = async (item) => {
        if (await confirmDelete(item.id)) {
            await deleteItem(item.id);
            await fillItems();
            editItem.pasos = editItem.pasos.filter(p => p.id !== item.id);
        }
    }

    const handleTableChange = (pagination, filters, sorter, extra) => {
        let params = {
            ...tableParams,
            pagination,
            filters,
            sorter,
        };
        fillItems(params);
    }

    //#region pasos

    const [editPaso, setEditPaso] = useState(defaultPaso);
    const [visibleFormPaso, setVisibleFormPaso] = useState(false);
    const [loadingEstado, setLoadingEstado] = useState(false);

    const newPaso = () => {
        setEditPaso({ ...defaultPaso, caso_id: editItem.id });
        setVisibleFormPaso(true);
    }

    const selectPaso = (item) => {
        setEditPaso(item);
        setVisibleFormPaso(true);
    }

    const handle_save_paso = (item) => {
        return new Promise(async (resolve, reject) => {
            try {
                if (item === editPaso) { showInfo("No hay cambios."); resolve(); return; }
                setLoading(true);
                let item_action = (item.id === 0) ? createPaso(item) : updatePaso(item);
                let res = await item_action;

                if (item.id === 0) {
                    item.id = res.data.id;
                    fillItems();
                    setEditItem(prev => ({ ...prev, pasos: [...prev.pasos, res.data] }));
                } else {
                    fillItems();
                    setEditItem(prev => ({
                        ...prev, pasos: prev.pasos.map(p => {
                            return (p.id === res.data.id) ? res.data : p;
                        }
                        )
                    }))
                    /* dispatch({ type: "UPDATE", payload: item });  */
                }
                showSuccess("¡Guardado correcto!");
                resolve();
            } catch (e) {
                showError(e.message);
                reject(e);
            } finally { setLoading(false); }
        });
    }

    const handle_delete_paso = async (item) => {
        if (await confirmDelete(item.id)) {
            await deletePaso(item.id);
            fillItems();
            setEditItem(prev => ({ ...prev, pasos: prev.pasos.filter(p => p.id !== item.id) }));
        }
    }

    const closeFormPaso = () => {
        setVisibleFormPaso(false);
    }

    const changeEstado = async (id, estado) => {
        let ant_estado = editItem.pasos.find(p => p.id === id).estado;
        try {
            setLoadingEstado(true);
            setEditItem(prev => ({ ...prev, pasos: prev.pasos.map(ps => (ps.id === id) ? { ...ps, estado: estado } : ps) }));
            let res = await estadoPaso(id, estado);
            fillItems();
        } catch (error) {
            setEditItem(prev => ({ ...prev, pasos: prev.pasos.map(ps => (ps.id === id) ? { ...ps, estado: ant_estado } : ps) }));
        }
        finally { setLoadingEstado(false); }
    }

    const changeNo = async (id, action) => {
        let res = await changeno({
            caso_id: editItem.id,
            paso_id: id,
            action: action
        });
        setEditItem(prev => ({ ...prev, pasos: res.data }));
        fillItems();
    }

    //#endregion pasos

    //#region pagos
    const [editPago, setEditPago] = useState(defaultPago);
    const [visibleModalPagos, setVisibleModalPagos] = useState(false);
    const [visibleFormPago, setVisibleFormPago] = useState(false);
    const [loadingPago, setLoadingPago] = useState(false);
    const [loadingEstadoPago, setLoadingEstadoPago] = useState(false);

    const newPago = () => {
        setEditPago({ ...defaultPago, caso_id: editItem.id });
        setVisibleFormPago(true);
    }

    const selectPago = (item) => {
        setEditPago(item);
        setVisibleFormPago(true);
    }

    const handle_save_pago = (item) => {
        return new Promise(async (resolve, reject) => {
            try {
                if (item === editPago) { showInfo("No hay cambios."); resolve(); return; }
                setLoadingPago(true);
                let item_action = (item.id === 0) ? createPago(item) : updatePago(item);
                let res = await item_action;

                if (item.id === 0) {
                    item.id = res.data.id;
                    fillItems();
                    setEditItem(prev => ({ ...prev, pagos: [...prev.pagos, res.data] }));
                } else {
                    fillItems();
                    setEditItem(prev => ({
                        ...prev, pagos: prev.pagos.map(p => {
                            return (p.id === res.data.id) ? res.data : p;
                        }
                        )
                    }))
                    /* dispatch({ type: "UPDATE", payload: item });  */
                }
                showSuccess("¡Guardado correcto!");
                resolve();
            } catch (e) {
                showError(e.message);
                reject(e);
            } finally { setLoadingPago(false); }
        });
    }

    const handle_delete_pago = async (item) => {
        if (await confirmDelete(item.id)) {
            await deletePago(item.id);
            fillItems();
            setEditItem(prev => ({ ...prev, pagos: prev.pagos.filter(p => p.id !== item.id) }));
        }
    }

    const showModalPagos = (item) => {
        setEditItem(item);
        setVisibleModalPagos(true);
    }

    const closeModalPagos = () => {
        setEditItem(defaultItem);
        setVisibleModalPagos(false);
    }

    const closeFormPago = () => {
        setVisibleFormPago(false);
    }

    const changeEstadoPago = async (id, estado) => {
        let ant_estado = editItem.pagos.find(p => p.id === id).estado;
        try {
            setLoadingEstadoPago(true);
            setEditItem(prev => ({ ...prev, pagos: prev.pagos.map(ps => (ps.id === id) ? { ...ps, estado: estado } : ps) }));
            let res = await estadoPago(id, estado);
            fillItems();
        } catch (error) {
            setEditItem(prev => ({ ...prev, pagos: prev.pagos.map(ps => (ps.id === id) ? { ...ps, estado: ant_estado } : ps) }));
        }
        finally { setLoadingEstadoPago(false); }
    }

    //#endregion pagos

    //#region documentos
    const [visibleModalDocumentos, setVisibleModalDocumentos] = useState(false);
    const [loadingUploadDocumentos, setLoadingUploadDocumentos] = useState(false);

    const showModalDocumentos = (item) => {
        setEditItem(item);
        setVisibleModalDocumentos(true);
    }

    const closeModalDocumentos = () => {
        setEditItem(defaultItem);
        setVisibleModalDocumentos(false);
    }

    const uploadDocumentos = async (descripcion, files) => {
        let formData = new FormData();
        formData.append('descripcion', descripcion);

        files.forEach(file => {
            formData.append('documentos[]', file);
        });

        try {
            setLoadingUploadDocumentos(true);
            let res = await upload_documentos(editItem, formData);

            setEditItem(prev => ({ ...prev, documentos: res.data.documentos }))
            fillItems();
        } catch (error) {

        } finally { setLoadingUploadDocumentos(false); }
    }

    const deleteDocumentos = async (item) => {
        if (await confirmDelete(item.id)) {
            try {
                setLoadingUploadDocumentos(true);
                let res = await delete_documentos(item);
                setEditItem(prev => ({ ...prev, documentos: res.data.documentos }));
            } catch (error) { }
            finally { setLoadingUploadDocumentos(false); }
        }
    }

    //#endregion documentos

    //#region upload massive

    const showModalFile = () => {
        setModalFileVisibility(true);
    }

    const hideModalFile = () => {
        setModalFileVisibility(false);
    }

    const setFileParam = (file) => {
        setFile(file);
    }

    const submitUploadFile = async (values) => {
        if (!file) {
            notification.error({
                message: 'No hay ningún archivo seleccionado.'
            });
        }

        let formData = new FormData();
        formData.append('massive_file', file);

        try {
            setFileLoading(true);
            let res = await connector.post(`/api/upload-massive-file-casos`, formData);
            notification.success({
                message: "'Importación finalizada.'"
            });
            fillItems();
            setModalFileVisibility(false);
        } catch (error) {
            notification.error(error.response?.data);
            console.log(error);
        }
        finally { setFileLoading(false); }
    }

    //#endregion

    return {
        casos: {
            editItem,
            fillItems,
            items,
            fillResources,
            resources,
            newItem,
            selectItem,
            visibleForm,
            closeForm,
            handle_save,
            handle_delete,
            tableParams,
            loading,
            handleTableChange
        },
        pasos: {
            editPaso,
            newPaso,
            selectPaso,
            visibleFormPaso,
            closeFormPaso,
            handle_save_paso,
            handle_delete_paso,
            changeEstado,
            loadingEstado,
            changeNo
        },
        pagos: {
            newPago,
            selectPago,
            handle_save_pago,
            handle_delete_pago,
            visibleModalPagos,
            showModalPagos,
            closeModalPagos,
            closeFormPago,
            changeEstadoPago,
            editPago,
            visibleFormPago,
            loadingPago,
            loadingEstadoPago
        },
        documentos: {
            loadingUploadDocumentos,
            visibleModalDocumentos,
            showModalDocumentos,
            closeModalDocumentos,
            uploadDocumentos,
            deleteDocumentos,
        },
        fileModalParams: {
            showModalFile,
            hideModalFile,
            modalFileVisibility,
            fileLoading,
            setFileParam,
            file,
            submitUploadFile
        },
    };
}
